import { IconProps } from '../icon';

export function AlignementCentreIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256.07 208.17"
      {...props}
    >
      <g id="a" />
      <g id="b">
        <g id="c">
          <g>
            <path d="M127.98,16.05c-38.66,0-77.33,0-115.99,0-1.5,0-3.01,.09-4.5-.05C3.1,15.58,.04,12.3,0,8.11-.04,3.94,3.01,.55,7.35,.09c1.48-.16,3-.06,4.5-.06,77.49,0,154.98,0,232.48,0,1.33,0,2.67-.07,4,.04,4.65,.38,7.84,3.78,7.74,8.15-.1,4.18-3.19,7.39-7.6,7.79-1.49,.13-3,.04-4.5,.04-38.66,0-77.33,0-115.99,0Z" />
            <path d="M127.51,144.13c-38.5,0-76.99,0-115.49,0-1.5,0-3.01,.09-4.5-.05C3.13,143.66,.06,140.4,0,136.22c-.06-4.19,2.97-7.58,7.32-8.06,1.48-.16,3-.06,4.5-.06,77.49,0,154.98,0,232.48,0,.33,0,.67,0,1,0,7.15,.02,10.87,2.84,10.77,8.16-.1,5.15-3.71,7.86-10.56,7.86-39.33,0-78.66,0-117.99,0Z" />
            <path d="M128.07,80.09c-26.99,0-53.98,0-80.98,0-1.5,0-3.05,.18-4.48-.15-4-.93-6.49-3.49-6.54-7.69-.06-4.44,2.46-7.12,6.72-8.04,1.44-.31,2.99-.13,4.49-.13,53.82,0,107.64,0,161.45,0,1.33,0,2.68-.09,4,.06,4.35,.48,7.38,3.86,7.33,8.04-.05,4.18-3.12,7.44-7.51,7.88-1.32,.13-2.66,.05-4,.05-26.83,0-53.65,0-80.48,0Z" />
            <path d="M127.52,208.16c-17.16,0-34.31,.01-51.47,0-6.38,0-9.95-2.86-10.03-7.89-.08-5.06,3.54-8.12,9.8-8.12,34.81-.02,69.63-.02,104.44,0,6.25,0,9.87,3.07,9.78,8.14-.09,5.02-3.67,7.86-10.04,7.87-17.49,.02-34.98,0-52.47,0Z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AlignementCentreIcon;
